import types from "./types";

const INITIAL_STATE = {
	complain: null,
	complainError: null,
	complainLoading: false,

	//create
	createcomplain: null,
	createcomplainError: null,
	createcomplainLoading: false,

	//update
	updatecomplain: null,
	updatecomplainError: null,
	updatecomplainLoading: false,

	//delete
	deletecomplain: null,
	deletecomplainError: null,
	deletecomplainLoading: false,

	//single item

	singleItem: null,
};

const ComplainReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case types.GET_COMPLAIN_START:
			return {
				...state,
				complain: null,
				complainError: null,
				complainLoading: true,
			};
		case types.GET_COMPLAIN_SUCCESS:
			return {
				...state,
				complain: action.payload,
				complainLoading: false,
			};
		case types.GET_COMPLAIN_ERROR:
			return {
				...state,
				complainError: action.payload,
				complainLoading: false,
			};
		case types.GET_COMPLAIN_RESET:
			return {
				...state,
				complainError: null,
				complainLoading: false,
			};
		//create

		case types.CREATE_COMPLAIN_START:
			return {
				...state,
				createcomplain: null,
				createcomplainError: null,
				createcomplainLoading: true,
			};
		case types.CREATE_COMPLAIN_SUCCESS:
			return {
				...state,
				createcomplain: action.payload,
				createcomplainLoading: false,
			};
		case types.CREATE_COMPLAIN_ERROR:
			return {
				...state,
				createcomplainError: action.payload,
				createcomplainLoading: false,
			};
		case types.CREATE_COMPLAIN_RESET:
			return {
				...state,
				createcomplainError: null,
				createcomplainLoading: false,
			};
		//delete

		case types.DELETE_COMPLAIN_START:
			return {
				...state,
				deletecomplain: null,
				deletecomplainError: null,
				deletecomplainLoading: true,
			};
		case types.DELETE_COMPLAIN_SUCCESS:
			return {
				...state,
				deletecomplain: action.payload,
				deletecomplainLoading: false,
			};
		case types.DELETE_COMPLAIN_ERROR:
			return {
				...state,
				deletecomplainError: action.payload,
				deletecomplainLoading: false,
			};
		case types.DELETE_COMPLAIN_RESET:
			return {
				...state,
				deletecomplain: null,
				deletecomplainError: null,
				deletecomplainLoading: false,
			};

		//update
		case types.UPDATE_COMPLAIN_START:
			return {
				...state,
				updatecomplain: null,
				updatecomplainError: null,
				updatecomplainLoading: true,
			};
		case types.UPDATE_COMPLAIN_SUCCESS:
			return {
				...state,
				updatecomplain: action.payload,
				updatecomplainLoading: false,
			};
		case types.UPDATE_COMPLAIN_ERROR:
			return {
				...state,
				updatecomplainError: action.payload,
				updatecomplainLoading: false,
			};
		case types.UPDATE_COMPLAIN_RESET:
			return {
				...state,
				updatecomplain: null,
				updatecomplainError: null,
				updatecomplainLoading: false,
			};
		//singleItem
		// case types.SINGLE_COMPLAIN_START:
		// 	return {
		// 		...state,
		// 		updatecomplain: null,
		// 		updatecomplainError: null,
		// 		updatecomplainLoading: true,
		// 	};
		// case types.SINGLE_COMPLAIN_SUCCESS:
		// 	return {
		// 		...state,
		// 		updatecomplain: action.payload,
		// 		updatecomplainLoading: false,
		// 	};
		// case types.SINGLE_COMPLAIN_ERROR:
		// 	return {
		// 		...state,
		// 		updatecomplainError: action.payload,
		// 		updatecomplainLoading: false,
		// 	};
		// case types.SINGLE_COMPLAIN_RESET:
		// 	return {
		// 		...state,
		// 		updatecomplainError: null,
		// 		updatecomplainLoading: false,
		// 	};

		default:
			return { ...state };
	}
};

export default ComplainReducer;
